import { RequestServerClass } from '../../util/request';
import publishObjectPath from '@/util/configRegistry';
import { changePostParam } from '@/util/changePostParam';

const serverUrl = publishObjectPath.serverUrl;
const qs = require('qs');
const conttype = 'application/x-www-form-urlencoded';

export class HiddenDangerLibraryServer {
  public rSerivce: any;

  constructor(opt: any, axiosFilterFn?: any) {
    this.rSerivce = new RequestServerClass(opt);
    axiosFilterFn.call(this, this.rSerivce.serverObj);
  }

  // 隐患库
  // 分页查询所有数据
  public getHazardManageList(opts: object) {
    const url = serverUrl + '/api/yunnan/hazardManage';
    return this.rSerivce.serverObj.get(url, {
      params: opts,
    });
  }

  // 隐患库 详情
  public getHazardManageDetail(id: any) {
    const url = serverUrl + `/api/yunnan/hazardManage/${id}`;
    return this.rSerivce.serverObj.get(url);
  }

  // 隐患库  删除
  public deleteHazardManage(id: any) {
    const url = serverUrl + '/api/yunnan/hazardManage?idList=' + id;
    return this.rSerivce.serverObj.delete(url);
  }
  // 隐患来源列表
  public getHazardSourceList(opts: object) {
    const url = serverUrl + `/api/yunnan/hazardManage/source/list`;
    return this.rSerivce.serverObj.get(url, {
      params: opts,
    });
  }
  // 检查报表
  public getHazardManageStatisticReport(opts: object) {
    const url = serverUrl + '/api/yunnan/hazardManage/statisticReport';
    return this.rSerivce.serverObj.get(url, {
      params: opts,
    });
  }
  /*  ↑ 安环检查 -> 检查清单 ↑  */
}
